import { Column } from '@miq/catalog';

/**
 * Helper used to verify a column is not present inf FavoritesMap and is also not required
 * if condition is fulfilled it means column should NOT be visible
 * @param favorites
 * @param column
 */
export const columnNotFavoriteNotRequired = (favorites: { [key: number]: boolean }, column: Column): boolean =>
  !favorites[column.columnId] && !column.required;
